import React, { useState, useEffect } from 'react'
import './profile.css'
import { Link, useParams } from 'react-router-dom'
import ProfileCard from './ProfileCard'
import ProfileForm from './ProfileForm'
import ProfileTable from './ProfileTable'
import ChangePassword from './ChangePassword'
import {useSelector, useDispatch} from 'react-redux'
import { getUserInfo } from '../../api'


const Profile = () => {
    const {user} = useSelector((state) => state.user);
    const [profileTab, setProfileTab] = useState('profile')
    const [profileInfo, setProfileInfo] = useState({})
    const dispatch = useDispatch()
    const {id} = useParams()


    const handleChangeTab = (val) => {
        setProfileTab(val)
    }

    const fetchUserInfo = async () => {
        try{
            const res = await getUserInfo(user?.token, id)
            setProfileInfo(res?.data)
        }catch(error){
            console.log(error)
        }
    }
    useEffect(()=>{
        if(id)fetchUserInfo()
    },[id])

  return (
    <section className='profile'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
            <div className="heading-item">
                <h3 className="heading-title">Profile | </h3>
                <i class='bx bx-home heading__title-icon'></i>
                <Link to="/" className="heading-text">
                Home <i class='bx bx-chevron-right heading-icon'></i>
                </Link>
                <span className="heading-text">
                Profile <i class='bx bx-chevron-right heading-icon'></i>
                </span>
            </div>
            <p className="heading-text">
                Profile Informations
            </p>
            </div>
        </div>

        <div className="profile__container">
            <div className="profile__left">
                <div className="profile__left-tabs">
                    <button onClick={()=>handleChangeTab('profile')}
                    className={`profile__left-tab ${
                        profileTab === "profile" ? "active" : ""
                    }`}>
                        Profie Informations
                    </button>
                    <button onClick={()=>handleChangeTab('update')}
                    className={`profile__left-tab ${
                        profileTab === "update" ? "active" : ""
                    }`}>
                        Update Profile
                    </button>
                    <button onClick={()=>handleChangeTab('password')}
                    className={`profile__left-tab ${
                        profileTab === "password" ? "active" : ""
                    }`}>
                        Change Password
                    </button>
                    <button onClick={()=>handleChangeTab('assets')}
                    className={`profile__left-tab ${
                        profileTab === "assets" ? "active" : ""
                    }`}>
                        Assets
                    </button>
                </div>
            </div>
            <div className="profile__right">
                {profileTab === 'profile' && <ProfileCard user={user} id={id} staff={profileInfo}/>}
                {profileTab === 'update' && <ProfileForm user={user} 
                dispatch={dispatch} staff={profileInfo}
                fetchUserInfo={fetchUserInfo}/>}
                {profileTab === 'assets' && <ProfileTable user={user} staff={profileInfo}/>}
                {profileTab === 'password' && <ChangePassword user={user}/>}
            </div>
        </div>
    </section>
  )
}

export default Profile